import fetch from 'isomorphic-unfetch'
import ProjectConfig from '../../project.config'
import NetworkUtil from './network'
import { BaseEnv, UtilDevice } from '@iskytrip/sdk'

let serviceFetch

const baseEnvInstance = new BaseEnv()

serviceFetch = function(url, obj, method) {
	if (method === undefined) method = 'post'

	method = method.toLowerCase()

	return new Promise((resolve, reject) => {
		if (url.indexOf('http') === -1) {
			if (ProjectConfig.useLocalService) {
				url = baseEnvInstance.getDomain() + ProjectConfig.urlPrefix + url
			} else {
				url = ProjectConfig.serviceHotelOrder + url
			}
		}

		if (UtilDevice.isApp()) {
			if (obj && obj.request) obj = obj.request

			if (method === 'get') {
				NetworkUtil.get(url, obj)
					.then(resolve)
					.catch(reject)
			} else if (method === 'post') {
				NetworkUtil.post(url, obj)
					.then(resolve)
					.catch(reject)
			}
		} else {
			fetch(url, {
				method: method,
				headers: {
					'Content-Type': 'application/json',
				},
				credentials: 'include',
				body: JSON.stringify(obj),
			})
				.then((res) => {
					resolve(res.json())
				})
				.catch(reject)
		}
	})
}

export default serviceFetch
